import { deriveOverUnderResult, isCleanOverUnderLine, parseOverUnderSettlementMetadata, } from '../over-under/over-under.js';
import { deriveSpreadResult, parseSpreadSettlementMetadata } from '../spread/spread.js';
export const parseDerivedSettlementMetadata = (value) => parseOverUnderSettlementMetadata(value) ?? parseSpreadSettlementMetadata(value);
/**
 * Derives one Reel Option's result from its market's staged figure against
 * the proposition frozen on that Reel Option (GL-19, INV-16). The staged
 * figure is the resulted total for an over/under market and the home margin
 * (home points minus away points) for a spread (CAE-1632). The adapter's live
 * path and the reconciliation sweep both call this, so the two cannot drift
 * (GL-20).
 *
 * An over/under push is held for an operator, as delivered. A spread push
 * settles as void, because a spread is only offered on a half-point line and
 * a whole-number one is an exception the ticket rules void.
 */
export const deriveReelOptionResult = (input) => {
    const metadata = parseDerivedSettlementMetadata(input.settlementMetadata);
    if (metadata === null)
        return { kind: 'not_derived' };
    if (!isCleanOverUnderLine(metadata.line))
        return { kind: 'quarter_line', metadata };
    if (metadata.settlementType === 'SPREAD') {
        const result = deriveSpreadResult({
            homeMargin: input.stagedScore,
            side: metadata.side,
            line: metadata.line,
        });
        return { kind: 'derived', result, metadata };
    }
    const result = deriveOverUnderResult({
        score: input.stagedScore,
        line: metadata.line,
        direction: metadata.direction,
    });
    if (result === 'PUSH')
        return { kind: 'push', metadata };
    return { kind: 'derived', result, metadata };
};
/** The fields that name a derived proposition in a log line or an event. */
export const derivedPropositionFields = (metadata) => metadata.settlementType === 'SPREAD'
    ? { side: metadata.side }
    : { direction: metadata.direction };
//# sourceMappingURL=derived-settlement.js.map